<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "RequestRG",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
